import React from 'react';
import { Container, Card } from 'react-bootstrap';
import { FaEnvelope, FaFacebook, FaInstagram, FaTwitter } from 'react-icons/fa';
import SEO from './SEO';

const ContactUs = () => {
  return (
    <Container className="my-5 text-center" style={{ maxWidth: '600px' }}>
      <SEO
        title="Contact Us - My Exam World | Support & Inquiries"
        description="Have questions or feedback? Contact My Exam World support team via email or social media."
        url="/contactus"
      />
      <h1 className="mb-4">Contact My Exam World</h1>
      
      <Card className="shadow p-4">
        <h5 className="mb-4">Get in touch with us</h5>
        
        <div className="mb-4">
          <a href="mailto:myexamworld1@gmail.com" className="text-decoration-none">
            <FaEnvelope className="me-2" size={24} />
            myexamworld1@gmail.com
          </a>
        </div>
        
        <div className="d-flex justify-content-center gap-4">
          <a href="https://www.facebook.com/myexamworld" target="_blank" rel="noopener noreferrer">
            <FaFacebook size={32} className="text-primary" />
          </a>
          <a href="https://www.instagram.com/my_exam_world_" target="_blank" rel="noopener noreferrer">
            <FaInstagram size={32} className="text-danger" />
          </a>
          <a href="https://x.com/myexamworld" target="_blank" rel="noopener noreferrer">
            <FaTwitter size={32} className="text-dark" />
          </a>

        </div>
      </Card>
    </Container>
  );
};

export default ContactUs;